import {
  createContext,
  useContext,
  useEffect,
  useState,
  type ReactNode,
} from "react";
import { useLocation, useNavigate } from "react-router-dom";
export type Language = "en" | "he";
const I18nContext = createContext({
  language: "en" as Language,
  t: (en: string, _he: string) => en,
  setLanguage: (_language: Language) => {},
});
export function I18nProvider({ children }: { children: ReactNode }) {
  const location = useLocation();
  const navigate = useNavigate();
  const [language, setState] = useState<Language>(() =>
    location.pathname.startsWith("/he")
      ? "he"
      : typeof localStorage !== "undefined" &&
          localStorage.getItem("heritage-language") === "he"
        ? "he"
        : "en",
  );
  useEffect(() => {
    document.documentElement.lang = language;
    document.documentElement.dir = language === "he" ? "rtl" : "ltr";
    localStorage.setItem("heritage-language", language);
  }, [language]);
  useEffect(() => {
    if (location.pathname.startsWith("/he")) setState("he");
    else if (
      !location.pathname.startsWith("/app") &&
      !location.pathname.startsWith("/invite")
    )
      setState("en");
  }, [location.pathname]);
  function setLanguage(value: Language) {
    setState(value);
    if (
      !location.pathname.startsWith("/app") &&
      !location.pathname.startsWith("/invite")
    ) {
      const base = location.pathname.replace(/^\/he(?=\/|$)/, "") || "/";
      navigate(
        (value === "he" ? "/he" : "") +
          (base === "/" ? "" : base) +
          location.search,
      );
    }
  }
  return (
    <I18nContext.Provider
      value={{
        language,
        t: (en, he) => (language === "he" ? he : en),
        setLanguage,
      }}
    >
      {children}
    </I18nContext.Provider>
  );
}
export const useI18n = () => useContext(I18nContext);
export const PRODUCT_NAME =
  import.meta.env.VITE_PRODUCT_NAME || "Family Heritage Workspaces";

export const PRODUCT_SHORT_NAME =
  import.meta.env.VITE_PRODUCT_SHORT_NAME ||
  (PRODUCT_NAME === "Family Heritage Workspaces" ? "Heritage" : PRODUCT_NAME);
